module.exports = __webpack_public_path__ + "img/feixinlogo.acfe633b.png";